<template>
  <div class="container">
    <!--<approve-pending-jobs></approve-pending-jobs>-->
    <table :key="change">
      <tr>
        <th>date</th>
        <th>Verified user count</th>
        <th>Unverified user count</th>
      </tr>
      <tr v-for="(item, index) in candidates" :key="index">
        <td>{{ item.updated_at_date }}</td>
        <td>{{ item.verified_user_count }}</td>
        <td>{{ item.unverified_users_count }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
// import ApprovePendingJobs from "./pending-jobs";
import { GET_ADMIN_DASHBOARD } from "../../Api/admin_api";
export default {
  name: "dashboard",
  data: function () {
    return {
      candidates: [],
      change:0
    };
  },
  components: {
    // ApprovePendingJobs
  },
  mounted() {
    GET_ADMIN_DASHBOARD()
      .then((res) => {
        this.candidates = res.candidates_count.sort((a,b)=>b.updated_at-a.updated_at);
        this.change++
      })
      .catch();
  },
};
</script>

<style scoped>
table {
  margin: 5rem 0;
  font-family: arial, sans-serif;
  border-collapse: separate;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  border-radius: 0.4rem;
}

tr:nth-child(even) {
  background-color: #ebebeb;
}
</style>
